import { useQuery } from '@tanstack/react-query';

import { DispensariesApi } from 'api';
import { useUser } from 'hooks/queries';
import { BANK_DISPENSARY_INTERNAL_DOCUMENTS_KEY } from '../../keys';

export function useInternalDocuments(dispensaryId: string) {
  const dispensariesApi = new DispensariesApi();
  const { userBankId } = useUser();

  const { data: internalDocuments, isLoading: isLoadingInternalDocuments } = useQuery({
    enabled: !!dispensaryId.length || !!userBankId,
    queryKey: [BANK_DISPENSARY_INTERNAL_DOCUMENTS_KEY, userBankId, dispensaryId],
    queryFn: () => dispensariesApi.getInternalDocuments(userBankId, dispensaryId)
  });

  return { internalDocuments, isLoadingInternalDocuments };
}
